(()=>{
  /* Reveal-on-scroll that works with the theme's smooth scroller; content is never left hidden. */
  const els=[...document.querySelectorAll('.mr-reveal')];
  const vh=()=>window.innerHeight||800;
  els.forEach((el,i)=>{ if(el.getBoundingClientRect().top>vh()*0.95){ /* hiding disabled */ el.style.transitionDelay=(i%4)*70+'ms'; } });
  let ticking=false;
  const check=()=>{ticking=false; document.querySelectorAll('.mr-reveal.mr-pre:not(.is-in)').forEach(el=>{ if(el.getBoundingClientRect().top<vh()*0.92) el.classList.add('is-in'); });};
  const onScroll=()=>{ if(!ticking){ticking=true; requestAnimationFrame(check);} };
  document.addEventListener('scroll',onScroll,{capture:true,passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  if('IntersectionObserver' in window){const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:0.05}); els.forEach(el=>io.observe(el));}
  setTimeout(()=>els.forEach(el=>el.classList.add('is-in')),4000);
  check();
  const b=document.querySelector('.mr-burger'),d=document.querySelector('.mr-drawer');
  if(b&&d){b.addEventListener('click',()=>{const o=d.classList.toggle('is-open');b.setAttribute('aria-expanded',o)});}
})();
